<template>
  <div class="container">
    <div class="pay-result">
      <div class="error">
        <div class="image">
          <img src="../../../assets/images/payFail.png" class="fail" />
        </div>
        <div class="msg">绑定失败</div>
        <div class="btns" @click="onPage">
          <button class="shopping">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    onPage() {
        this.$router.replace("user");
    }
  }
};
</script>
<style lang="less" scoped>
.pay-result {
  padding-top: 23vw;
  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .msg {
      color: #ff526c;
      font-size: 26px;
      margin: 23px 0 147px;
    }
  }
  .error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .msg {
      color: #999999;
      font-size: 26px;
      margin: 23px 0 147px;
    }
  }
  .image {
    width: 189px;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .btn {
    text-align: center;
    color: #989898;
    margin-bottom: 27px;
  }
}
</style>